import { useI18nStore } from './i18n.store';

export const useDictionary = () => {
  return useI18nStore((s) => s.dictionary);
};

export const getDictionary = () => {
  return useI18nStore.getState().dictionary;
};
